//87
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { Bedsheet, PaintColorMaterial } from '../../utils/materials';

//multi objects
export function Island_bed(props) {
  const { variantName } = useContext(CurrentContext);

  return (
    <>
      {variantName === 'Double' && <Island_bed_double />}
      {variantName === 'Queen' && <Island_bed_queen />}
      {variantName === 'King' && <Island_bed_king />}
      {variantName === 'Twin' && <Island_bed_twin />}
    </>
  );
}

export function Island_bed_double(props) {
  const { nodes, materials, scene } = useGLTF('models/Island Bed_Double.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-island_bed_double-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh castShadow geometry={nodes.Bedding.geometry} material={Bedsheet} />
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        // material={PaintColorMaterial}
        material={PaintColorMaterial}
      />
      <Shadow model={'Island Bed_Double'} />
    </group>
  );
}

export function Island_bed_queen(props) {
  const { nodes, materials, scene } = useGLTF('models/Island Bed_Queen.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-island_bed_queen-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh castShadow geometry={nodes.Bedding.geometry} material={Bedsheet} />
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'Island Bed_Queen'} />
    </group>
  );
}

export function Island_bed_king(props) {
  const { nodes, materials, scene } = useGLTF('models/Island Bed_King.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-island_bed_king-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <mesh castShadow geometry={nodes.Bedding.geometry} material={Bedsheet} />
      <Shadow model={'Island Bed_King'} />
    </group>
  );
}

export function Island_bed_twin(props) {
  const { nodes, materials, scene } = useGLTF('models/Island Bed_Twin.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-island_bed_twin-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <mesh castShadow geometry={nodes.Bedding.geometry} material={Bedsheet} />
      <Shadow model={'Island Bed_Twin'} />
    </group>
  );
}
